import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Project", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Medewerker "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Al geregistreerd.", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Toegang geweigerd.", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Contractpartij "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "BSN", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Documentnummer", -1)
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "VCA", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "error"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "GPI", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  class: "error"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("ID gecontroleerd "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Bouwplaatsmedewerker heeft kennis genomen van de algemene bouwplaatsregels en verklaart de voorschriften in acht te zullen nemen en instructies door de (hoofd-)uitvoerder op te volgen. "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Bouwplaats medewerker heeft kennis genomen van de steiger instructies.", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Bouwplaats medewerker heeft kennis genomen van de privacyverklaring. "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Handtekening / Signature "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", {
  class: "no-mb",
  style: {"color":"red","font-weight":"bold"}
}, "Deze medewerker is niet langer toegestaan op onze bouwplaatsen!", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Reden voor het ontzeggen van de toegang", -1)
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, "Door", -1)
const _hoisted_32 = { class: "no-mb" }

import { computed, onMounted, ref } from 'vue'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import { CloseOutlined, CheckOutlined } from '@ant-design/icons-vue'
import SignatureField from '@/components/SignatureField.vue'
import { ConstructionWorker } from '@/types/constructionWorker'
import { notification } from 'ant-design-vue'
import PageTitleBar from '@/components/PageTitleBar.vue'
import DenyConstructionWorker from '@/components/DenyConstructionWorker.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConstructionSiteRegistrationCreate',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref({ users: false, companies: false })

const project = ref<{ id:number, reference:string, name:string, city:string }|null>(null)
const constructionWorkers = ref<ConstructionWorker[]>([])
let constructionWorkerTimer = 0
const constructionWorker = ref<ConstructionWorker|null>(null)

const companies = ref<{ id:number, name:string }[]>([])
let companyTimer = 0

const signatureName = computed(() => {
  if (constructionWorker.value) {
    return 'Handtekening_bouwplaatsmedewerker_' + constructionWorker.value.id + '_Project_' + project.value?.id
  }

  return 'Handtekening_bouwplaatsmedewerker'
})

const allRequiredFieldsCompleted = computed(() => {
  return !!(
    registration.value.construction_worker_id &&
    registration.value.company_id &&
    registration.value.document_checked &&
    registration.value.agreed_to_rules &&
    registration.value.agreed_to_privacy_policy &&
    registration.value.signature &&
    (constructionWorker.value && !constructionWorker.value.denied.is_denied)
  )
})

const registration = ref<{ project_id:number|null, company_id:number|null, construction_worker_id:number|null, document_checked:number|null, agreed_to_rules:number|null, agreed_to_scaffolding_instructions:number|null, agreed_to_privacy_policy:number|null, signature:File|null }>({
  project_id: null,
  company_id: null,
  construction_worker_id: null,
  document_checked: null,
  agreed_to_rules: null,
  agreed_to_scaffolding_instructions: null,
  agreed_to_privacy_policy: null,
  signature: null
})

onMounted(() => {
  getProject()
})

function getProject () : void {
  axios.get(process.env.VUE_APP_API_URL + '/projects/' + route.params.projectId).then((r) => {
    project.value = r.data.data
    registration.value.project_id = r.data.data.id
  })
}

function searchConstructionWorkers (val:string) : void {
  if (val.length >= 3) {
    loading.value.users = true
    clearTimeout(constructionWorkerTimer)
    registration.value.construction_worker_id = null

    constructionWorkerTimer = setTimeout(() => {
      axios.get(process.env.VUE_APP_API_URL + '/constructionWorkers?filter[search]=' + val + '&sort=firstname&limit=250').then((res) => {
        constructionWorkers.value = res.data.data as ConstructionWorker[]
      }).finally(() => {
        loading.value.users = false
      })
    }, 500)
  } else {
    constructionWorkers.value = []
  }
}

function setConstructionWorker (id:number) : void {
  axios.get(process.env.VUE_APP_API_URL + '/constructionWorkers/' + id).then((r) => {
    constructionWorker.value = r.data.data
  })
}

function searchCompanies (val:string) : void {
  if (val.length >= 3) {
    loading.value.companies = true
    clearTimeout(companyTimer)
    registration.value.company_id = null

    companyTimer = setTimeout(() => {
      axios.get(process.env.VUE_APP_API_URL + '/companies?filter[search]=' + val + '&filter[active]=1&sort=name&limit=250').then((res) => {
        companies.value = res.data.data
      }).finally(() => {
        loading.value.companies = false
      })
    }, 500)
  } else {
    companies.value = []
  }
}

function saveSignature (file:File) : void {
  registration.value.signature = file
}

function registerConstructionWorker () : void {
  const formData = new FormData()

  if (registration.value.project_id &&
    registration.value.company_id &&
    registration.value.construction_worker_id &&
    registration.value.document_checked &&
    registration.value.agreed_to_rules &&
    registration.value.agreed_to_privacy_policy &&
    registration.value.signature
  ) {
    formData.append('project_id', registration.value.project_id.toString())
    formData.append('company_id', registration.value.company_id.toString())
    formData.append('construction_worker_id', registration.value.construction_worker_id.toString())
    formData.append('document_checked', registration.value.document_checked.toString())
    formData.append('agreed_to_rules', registration.value.agreed_to_rules.toString())
    formData.append('agreed_to_privacy_policy', registration.value.agreed_to_privacy_policy.toString())
    formData.append('signature', registration.value.signature)
  }

  if (registration.value.agreed_to_scaffolding_instructions !== null) {
    formData.append('agreed_to_scaffolding_instructions', registration.value.agreed_to_scaffolding_instructions.toString())
  }

  axios.post(process.env.VUE_APP_API_URL + '/constructionSiteRegistrations', formData).then(() => {
    router.push({ name: 'Dashboard' })
    notification.success({
      message: 'Medewerker geregistreerd.',
      description: 'De bouwplaatsmedewerker is succesvol geregistreerd op het project.',
      duration: 5
    })
  }).catch((e) => {
    if (e.response.status === 400) {
      notification.info({ message: 'Medewerker is al geregistreerd op dit project.', description: 'Medewerker hoeft niet meerdere keren geregistreerd te worden.' })
      router.push({ name: 'Dashboard' })
    } else {
      notification.error({ message: 'Fout tijdens registratie!', description: 'Er is iets mis gegaan. Probeer het later nog een keer.' })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(PageTitleBar, null, _createSlots({
            buttons: _withCtx(() => [
              _createVNode(_component_a_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Terug naar overzicht")
                ]),
                _: 1
              })
            ]),
            _: 2
          }, [
            (project.value)
              ? {
                  name: "title",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(project.value.name) + " (" + _toDisplayString(project.value.reference) + ").", 1)
                  ]),
                  key: "0"
                }
              : {
                  name: "title",
                  fn: _withCtx(() => [
                    _createTextVNode("Aan het laden..")
                  ]),
                  key: "1"
                }
          ]), 1024),
          _createVNode(_component_a_card, { title: "Medewerker registreren" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      (project.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(project.value.name) + " (" + _toDisplayString(project.value.reference) + ") te " + _toDisplayString(project.value.city) + ".", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_3, "Aan het laden.."))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createVNode(_component_a_select, {
                        placeholder: "Zoek op achternaam..",
                        "default-active-first-option": false,
                        "filter-option": false,
                        loading: loading.value.users,
                        value: registration.value.construction_worker_id,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((registration.value.construction_worker_id) = $event)),
                        onSearch: searchConstructionWorkers,
                        onChange: setConstructionWorker,
                        "show-search": ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(constructionWorkers.value, (worker) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: worker.id,
                              value: worker.id,
                              disabled: worker.projectIds.includes(parseInt(_unref(route).params.projectId)) || worker.denied.denied_at
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(worker.firstname) + " " + _toDisplayString(worker.lastname) + " (" + _toDisplayString(worker.date_of_birth) + ") ", 1),
                                (worker.projectIds.includes(parseInt(_unref(route).params.projectId)))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                      _createTextVNode(" | "),
                                      _hoisted_6
                                    ]))
                                  : _createCommentVNode("", true),
                                (worker.denied.is_denied)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                      _createTextVNode(" | "),
                                      _hoisted_8
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["value", "disabled"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["loading", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createVNode(_component_a_select, {
                        placeholder: "Zoek op bedrijfsnaam",
                        "default-active-first-option": false,
                        "filter-option": false,
                        loading: loading.value.companies,
                        value: registration.value.company_id,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((registration.value.company_id) = $event)),
                        onSearch: searchCompanies,
                        "show-search": ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companies.value, (company) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: company.id,
                              value: company.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(company.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["loading", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (constructionWorker.value && !constructionWorker.value.denied.is_denied)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_11,
                            _createElementVNode("p", null, _toDisplayString(constructionWorker.value.personal_identification_number), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_12,
                            _createElementVNode("p", null, _toDisplayString(constructionWorker.value.document_number) + ", geldig tot " + _toDisplayString(constructionWorker.value.document_expiry_date ? new Date(constructionWorker.value.document_expiry_date).toLocaleDateString('nl-NL') : 'Onbekend') + ".", 1),
                            (constructionWorker.value.document_expiry_date && new Date() > new Date(constructionWorker.value.document_expiry_date))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Let op! ID is verlopen!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_14,
                            (constructionWorker.value.vca_certified)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Ja, Geldig tot " + _toDisplayString(constructionWorker.value.vca_expiry_date ? new Date(constructionWorker.value.vca_expiry_date).toLocaleDateString('nl-NL') : 'Onbekend') + ".", 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_16, "Nee.")),
                            (constructionWorker.value.vca_certified && constructionWorker.value.vca_expiry_date && new Date() > new Date(constructionWorker.value.vca_expiry_date))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Let op! VCA verlopen!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_18,
                            (constructionWorker.value.gpi_certified)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Ja, Geldig tot " + _toDisplayString(constructionWorker.value.gpi_expiry_date ? new Date(constructionWorker.value.gpi_expiry_date).toLocaleDateString('nl-NL') : 'Onbekend') + ".", 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_20, "Nee.")),
                            (constructionWorker.value.gpi_certified && constructionWorker.value.gpi_expiry_date && new Date() > new Date(constructionWorker.value.gpi_expiry_date))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Let op! GPI verlopen!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_22,
                            _createVNode(_component_a_radio_group, {
                              "button-style": "solid",
                              value: registration.value.document_checked,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((registration.value.document_checked) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CloseOutlined))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CheckOutlined))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_23,
                            _createVNode(_component_a_radio_group, {
                              "button-style": "solid",
                              value: registration.value.agreed_to_rules,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((registration.value.agreed_to_rules) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CloseOutlined))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CheckOutlined))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_24,
                            _createVNode(_component_a_radio_group, {
                              "button-style": "solid",
                              value: registration.value.agreed_to_scaffolding_instructions,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((registration.value.agreed_to_scaffolding_instructions) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CloseOutlined))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CheckOutlined))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_25,
                            _createVNode(_component_a_radio_group, {
                              "button-style": "solid",
                              value: registration.value.agreed_to_privacy_policy,
                              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((registration.value.agreed_to_privacy_policy) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CloseOutlined))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CheckOutlined))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_26,
                            _hoisted_27,
                            _createVNode(SignatureField, {
                              "return-type": "file",
                              "signature-name": _unref(signatureName),
                              onSignatureSave: saveSignature,
                              onSignatureCleared: _cache[7] || (_cache[7] = ($event: any) => (registration.value.signature = []))
                            }, null, 8, ["signature-name"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              style: {"margin-right":"8px"},
                              disabled: !_unref(allRequiredFieldsCompleted),
                              onClick: registerConstructionWorker
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Registreren")
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            (constructionWorker.value)
                              ? (_openBlock(), _createBlock(DenyConstructionWorker, {
                                  key: 0,
                                  "construction-worker": constructionWorker.value,
                                  onUpdate: _cache[8] || (_cache[8] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                                }, null, 8, ["construction-worker"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : (constructionWorker.value && constructionWorker.value.denied.is_denied)
                  ? (_openBlock(), _createBlock(_component_a_row, {
                      key: 1,
                      gutter: [16,16]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_29,
                            _createElementVNode("div", {
                              innerHTML: constructionWorker.value.denied.reason
                            }, null, 8, _hoisted_30)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_31,
                            _createElementVNode("p", _hoisted_32, _toDisplayString(constructionWorker.value.denied.denied_by_user.full_name || '-') + " op " + _toDisplayString(constructionWorker.value.denied.denied_at ? new Date(constructionWorker.value.denied.denied_at).toLocaleString('nl-NL') : '-'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (registration.value.construction_worker_id && !constructionWorker.value)
                    ? (_openBlock(), _createBlock(_component_a_skeleton, {
                        key: 2,
                        active: ""
                      }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})